// extracted by mini-css-extract-plugin
export default {"container":"ChangeMemberRental_container__k23n7","boxForm":"ChangeMemberRental_boxForm__IGVw7"};